// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.venue-item {
  border-radius: 0;
  background: #fff;
  color: var(--ion-color-main);
  transition: 0.3s linear;
}
.venue-item.selected {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: white;
}
.venue-item p {
  margin: 0;
}
.venue-item .name {
  font-weight: bold;
  font-size: 16px;
}
.venue-item .address {
  font-weight: bold;
  font-size: 16px;
}

.distance {
  height: 21px;
  min-width: 45px;
  padding: 2px 8px !important;
  text-align: center;
  margin-right: 5px;
}

.second-row {
  margin-top: 2px;
}

.app-logo {
  width: 60px;
  height: 35px;
  color: var(--ion-color-gold);
}
.app-logo.selected {
  color: white;
}

.wrap {
  padding-top: 10px;
}

.icon {
  width: 20px;
  height: 20px;
  padding: 2px;
  color: var(--ion-color-main);
}
.icon.selected {
  color: white;
}

.map-icon {
  margin-left: 4px;
}

.info-icon {
  margin-left: 2px;
}

a {
  height: 21px;
}

.box {
  color: var(--ion-color-main);
  border: 2px solid var(--ion-color-main);
  padding: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.box.selected {
  color: white;
  border: 2px solid white;
}

.venue-status {
  color: white;
  background: var(--ion-color-gold);
  border-radius: 2px;
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px 8px !important;
  min-width: 45px;
  text-align: center;
  margin-right: 5px;
}
.venue-status.selected {
  background: white;
  color: var(--ion-color-primary);
}

.preorder-type {
  --background: #F4F4F4;
  color: #9F9F9F;
  font-weight: bold;
  cursor: pointer;
  --padding: 16px;
  border-radius: 0;
  border: 1px solid #C6DDE0;
  padding: 0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  margin: 0;
  --detail-icon-color: var(--ion-color-main);
  --detail-icon-opacity: 1;
}
.preorder-type.active {
  transition: 0.3s linear;
  --background: #F3FAFA;
  color: var(--ion-color-main);
}
.preorder-type h3 {
  font-family: AppFont-black, sans-serif;
  font-size: 14px;
}
.preorder-type p {
  color: var(--ion-color-primary);
  font-weight: 400;
}

.border-top {
  border-top: 0.5px solid #E8E8E8;
}

.align-center {
  text-align: center;
}

.button-separator {
  width: 3px;
  height: 100%;
}

.top-row {
  padding: 8px;
  min-height: 60px;
}

.small-margin-top {
  margin-top: 6px;
}

.top-end-img {
  position: absolute;
  top: 0;
  right: 0;
  height: 36px;
  width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-suggestion/venue-suggestion.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;AACF;AACE;EACE,uBAAA;EACA,iCAAA;EACA,YAAA;AACJ;AAEE;EACE,SAAA;AAAJ;AAGE;EACE,iBAAA;EACA,eAAA;AADJ;AAIE;EACE,iBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;AAHF;AAKE;EACE,YAAA;AAHJ;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;AAJF;AAME;EACE,YAAA;AAJJ;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,4BAAA;EACA,uCAAA;EACA,YAAA;EACA,0CAAA;AALF;AAOE;EACE,YAAA;EACA,uBAAA;AALJ;;AASA;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AANF;AAQE;EACE,iBAAA;EACA,+BAAA;AANJ;;AAUA;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,wCAAA;EACA,SAAA;EACA,0CAAA;EACA,wBAAA;AAPF;AASE;EACE,uBAAA;EACA,qBAAA;EACA,4BAAA;AAPJ;AAUE;EACE,sCAAA;EACA,eAAA;AARJ;AAWE;EACE,+BAAA;EACA,gBAAA;AATJ;;AAaA;EACE,+BAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAaA;EACE,UAAA;EACA,YAAA;AAVF;;AAaA;EACE,YAAA;EACA,gBAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAVF","sourcesContent":[".venue-item {\n  border-radius: 0;\n  background: #fff;\n  color: var(--ion-color-main);\n  transition: 0.3s linear;\n\n  &.selected {\n    transition: 0.3s linear;\n    background: var(--ion-color-main);\n    color: white;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  .name {\n    font-weight: bold;\n    font-size: 16px;\n  }\n\n  .address {\n    font-weight: bold;\n    font-size: 16px;\n  }\n}\n\n.distance {\n  height: 21px;\n  min-width: 45px;\n  padding: 2px 8px !important;\n  text-align: center;\n  margin-right: 5px;\n}\n\n.second-row {\n  margin-top: 2px;\n}\n\n.app-logo {\n  width: 60px;\n  height: 35px;\n  color: var(--ion-color-gold);\n\n  &.selected {\n    color: white;\n  }\n}\n\n.wrap {\n  padding-top: 10px;\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n  color: var(--ion-color-main);\n\n  &.selected {\n    color: white;\n  }\n}\n\n.map-icon {\n  margin-left: 4px;\n}\n\n.info-icon {\n  margin-left: 2px;\n}\n\na {\n  height: 21px;\n}\n\n.box {\n  color: var(--ion-color-main);\n  border: 2px solid var(--ion-color-main);\n  padding: 2px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\n  &.selected {\n    color: white;\n    border: 2px solid white;\n  }\n}\n\n.venue-status {\n  color: white;\n  background: var(--ion-color-gold);\n  border-radius: 2px;\n  font-size: 13px;\n  width: fit-content;\n  padding: 2px 8px !important;\n  min-width: 45px;\n  text-align: center;\n  margin-right: 5px;\n\n  &.selected {\n    background: white;\n    color: var(--ion-color-primary);\n  }\n}\n\n.preorder-type {\n  --background: #F4F4F4;\n  color: #9F9F9F;\n  font-weight: bold;\n  cursor: pointer;\n  --padding: 16px;\n  border-radius: 0;\n  border: 1px solid #C6DDE0;\n  padding: 0;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  margin: 0;\n  --detail-icon-color: var(--ion-color-main);\n  --detail-icon-opacity: 1;\n\n  &.active {\n    transition: 0.3s linear;\n    --background: #F3FAFA;\n    color: var(--ion-color-main);\n  }\n\n  h3 {\n    font-family: AppFont-black, sans-serif;\n    font-size: 14px;\n  }\n\n  p {\n    color: var(--ion-color-primary);\n    font-weight: 400;\n  }\n}\n\n.border-top {\n  border-top: 0.5px solid #E8E8E8;\n}\n\n.align-center {\n  text-align: center;\n}\n\n.button-separator {\n  width: 3px;\n  height: 100%;\n}\n\n.top-row {\n  padding: 8px;\n  min-height: 60px;\n}\n\n.small-margin-top {\n  margin-top: 6px;\n}\n\n.top-end-img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 36px;\n  width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
